"use client"; // Direktiva pro client-side komponentu

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { trackPageViewServerSide } from "../_lib/api";
const MATOMO_URL = process.env.NEXT_PUBLIC_MATOMO_URL;
const YOUR_SITE_ID = process.env.NEXT_PUBLIC_MATOMO_SITE_ID;

function MatomoTracker() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window !== "undefined") {
      // Matomo tracking code
      window._paq = window._paq || [];
      window._paq.push(["trackPageView"]);
      window._paq.push(["enableLinkTracking"]);
      (function () {
        var u = MATOMO_URL;
        window._paq.push(["setTrackerUrl", u + "matomo.php"]);
        window._paq.push(["setSiteId", YOUR_SITE_ID]);
        var d = document,
          g = d.createElement("script"),
          s = d.getElementsByTagName("script")[0];
        g.type = "text/javascript";
        g.async = true;
        g.src = u + "matomo.js";
        // nový kod - start
        g.onload = function () {
          console.log("Matomo.js successfully loaded");
        };

        g.onerror = async function () {
          console.warn(
            "Matomo.js was blocked, using server-side tracking instead",
          );

          const response = await trackPageViewServerSide(
            window.location.href,
            navigator.userAgent,
            document.referrer,
          );
          console.log(response.status);
          // Spustí server-side sledování, pokud je script zablokován
        };
        // nový kod - end
        s.parentNode.insertBefore(g, s);
      })();
    }

    // přidaný kod  - odkomentovaný - start

    // if (pathname) {
    //   trackPageViewServerSide(pathname, window.location.hostname, navigator.userAgent, document.referrer);
    // }
    // přidaný - odkomentovaný kód - end
  }, [pathname]);

  return null; // Komponenta nemá žádný vizuální obsah
}

export default MatomoTracker;
